import API from 'src/api'
import { http } from 'src/boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'widgets/',
  fetchPaginated () {
    return new Promise((resolve, reject) => {
      http.get(this.URL)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchResult (payload) {
    return new Promise((resolve, reject) => {
      http.post(this.URL + 'result/' + payload.id, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchDetails (id) {
    return new Promise((resolve, reject) => {
      http.get(this.URL + id + '/details')
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchDefaultWidgets () {
    return new Promise((resolve, reject) => {
      http.get(this.URL + 'default')
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      http.post(this.URL, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  update (payload) {
    return new Promise((resolve, reject) => {
      http.put(this.URL + `${payload.id}`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(this.URL + `${id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}
